/**
 * The iframe URL parameters through which the embed widget hands the chat its
 * visitor's identity, and the `embedData` field each one becomes.
 *
 * Kept on its own so two readers share ONE list: `chatApi.ts`, which turns the
 * URL into the `POST /api/chatrooms` body, and the Sentry scrub
 * (`common/observability/scrub-embed-identity.ts`), which must remove exactly
 * these from every URL an event carries. A second copy of the list is the drift
 * that would let a new identity param reach Sentry unscrubbed.
 */
export const EMBED_URL_KEY_MAP: Readonly<Record<string, string>> = {
  euid: "external_user_id",
  cid: "customer_id",
  user_hash: "user_hash",
  cname: "customer_name",
  cemail: "customer_email",
  cphone: "customer_phone",
  cattrs: "customer_attributes"
}

/**
 * Every URL parameter that carries the visitor's identity: the mapped keys above,
 * plus `sdata`, the free-form host-page blob a page can put anything into.
 */
export const EMBED_URL_IDENTITY_PARAMS: readonly string[] = [
  ...Object.keys(EMBED_URL_KEY_MAP),
  "sdata"
]
